import type { Theme } from '../../types/theme';

export const stripeTheme: Theme = {
  id: 'stripe',
  name: 'Stripe',
  description: 'Luxury fintech design with signature purple gradients. Weight 300 headlines and blue-tinted shadows.',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/stripe/DESIGN.md',
  visualKeywords: ['purple gradient', 'luxury', 'fintech', 'weight 300', 'blue shadows', 'precision'],
  colors: {
    background: '#ffffff',
    surface: '#f6f9fc',
    surfaceElevated: '#ffffff',
    surfaceDark: '#1c1e54',
    textPrimary: '#061b31',
    textSecondary: '#64748b',
    textMuted: '#8898aa',
    border: '#e5edf5',
    borderSubtle: '#f6f9fc',
    primary: '#533afd',
    primaryHover: '#4434d4',
    primaryActive: '#2e2b8c',
    accent: '#ea2261',
    onPrimary: '#ffffff',
    success: '#15be53',
    warning: '#9b6829',
    error: '#ea2261',
  },
  typography: {
    headingFont: '"SF Pro Display", -apple-system, system-ui, sans-serif',
    bodyFont: '"SF Pro Text", -apple-system, system-ui, sans-serif',
    monoFont: '"Source Code Pro", monospace',
    headingWeight: '300',
    bodyWeight: '300',
    letterSpacingHeading: '-0.96px',
    letterSpacingBody: '0',
  },
  radius: {
    button: '4px',
    card: '8px',
    panel: '6px',
    badge: '4px',
    input: '4px',
  },
  shadow: {
    card: '0 30px 45px -30px rgba(50,50,93,0.25), 0 18px 36px -18px rgba(0,0,0,0.1)',
    elevated: '0 14px 21px -14px rgba(3,3,39,0.25), 0 8px 17px -8px rgba(0,0,0,0.1)',
    button: 'none',
    none: 'none',
  },
  layout: {
    maxWidth: '1080px',
    sectionSpacing: '80px',
    cardPadding: '32px',
    navHeight: '72px',
  },
  mood: {
    density: 'medium',
    tone: 'confident, premium, financial-grade',
    productFit: ['Payment platforms', 'Fintech', 'Banking', 'E-commerce infrastructure'],
    bestFor: ['Financial products', 'Payment processing', 'B2B SaaS', 'Enterprise platforms'],
    notGoodFor: ['Social apps', 'Gaming', 'Healthcare', 'Education'],
  },
};
